<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="语言" required class="locale-select-item">
        <a-select
          mode="multiple"
          v-model="selectedLocales"
          placeholder="请选择语言"
          class="locale-select"
          :maxTagCount="4"
          :allowClear="false"
          @change="handleLocaleChange"
        >
          <a-select-option v-for="item in localeFields" :key="item.key" :value="item.key">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <div v-for="item in visibleLocaleFields" :key="item.key" class="locale-block">
        <a-form-model-item
          :label="item.label + '搜索词'"
          :prop="item.prop"
          class="locale-name-item"
        >
          <a-input
            class="locale-name-input"
            v-model="form[item.prop]"
            :placeholder="'请输入' + item.label + '搜索词'"
          />
        </a-form-model-item>
      </div>

      <a-form-model-item label="排序" prop="sort">
        <a-input-number v-model="form.sort" placeholder="请输入" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSearch, addSearch, updateSearch } from '@/api/video/search'

const LOCALE_FIELDS = [
  { key: 'zh', label: '中文简体', prop: 'content' },
  { key: 'tc', label: '中文繁体', prop: 'contentTc' },
  { key: 'en', label: '英文', prop: 'contentEn' },
  { key: 'jp', label: '日语', prop: 'contentJp' },
  { key: 'ko', label: '韩语', prop: 'contentKo' },
  { key: 'fr', label: '法语', prop: 'contentFr' },
  { key: 'ab', label: '阿拉伯语', prop: 'contentAb' },
  { key: 'vi', label: '越南语', prop: 'contentVi' }
]

const DEFAULT_SELECTED_LOCALES = ['zh']

const buildLocaleForm = () => {
  const fields = {}
  LOCALE_FIELDS.forEach(item => {
    fields[item.prop] = null
  })
  return fields
}

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      localeFields: LOCALE_FIELDS,
      selectedLocales: [...DEFAULT_SELECTED_LOCALES],
      form: {
        id: null,
        ...buildLocaleForm(),
        sort: null,
        status: 0,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    visibleLocaleFields () {
      return this.localeFields.filter(item => this.selectedLocales.includes(item.key))
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleLocaleChange (value) {
      if (!value || value.length === 0) {
        this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
        this.$message.warning('请至少选择一种语言')
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    resolveSelectedLocalesFromData (data) {
      const keys = LOCALE_FIELDS
        .filter(item => data && data[item.prop])
        .map(item => item.key)
      return keys.length ? keys : [...DEFAULT_SELECTED_LOCALES]
    },
    validateLocaleContent () {
      if (!this.selectedLocales || this.selectedLocales.length === 0) {
        this.$message.error('请至少选择一种语言')
        return false
      }
      const hasOneFilled = this.visibleLocaleFields.some(item => !!(this.form[item.prop] && String(this.form[item.prop]).trim()))
      if (!hasOneFilled) {
        this.$message.error('至少选择一种语言填写搜索词，不能全部为空')
        return false
      }
      return true
    },
    loadFormFromApi (data) {
      const form = {
        id: null,
        ...buildLocaleForm(),
        sort: null,
        status: 0,
        createTime: null,
        remark: null,
        ...(data || {})
      }
      LOCALE_FIELDS.forEach(item => {
        form[item.prop] = data && data[item.prop] != null ? data[item.prop] : ''
      })
      this.form = form
      this.selectedLocales = this.resolveSelectedLocalesFromData(form)
    },
    onClose () {
      this.open = false
      this.reset()
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
      this.form = {
        id: null,
        ...buildLocaleForm(),
        sort: null,
        status: 0,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSearch({ id }).then(response => {
        this.loadFormFromApi(response.data)
        this.open = true
        this.formTitle = '修改'
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        if (!this.validateLocaleContent()) {
          return false
        }
        this.submitLoading = true
        if (this.form.id !== undefined && this.form.id !== null) {
          updateSearch(this.form).then(response => {
            this.$message.success('修改成功', 3)
            this.open = false
            this.$emit('ok')
            this.reset()
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          addSearch(this.form).then(response => {
            this.$message.success('新增成功', 3)
            this.open = false
            this.$emit('ok')
            this.reset()
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.locale-select-item {
  :deep(.ant-form-item-control) {
    line-height: 1.5;
  }
}

.locale-select {
  width: 520px;
  max-width: 100%;

  :deep(.ant-select-selection) {
    min-height: 40px;
    padding: 4px 8px;
    border-radius: 6px;
  }

  :deep(.ant-select-selection--multiple .ant-select-selection__choice) {
    height: 28px;
    line-height: 26px;
    margin: 2px 4px 2px 0;
    padding: 0 8px;
    border-radius: 4px;
    background: #f0f5ff;
    border-color: #d6e4ff;
    color: #2f54eb;
  }

  :deep(.ant-select-selection--multiple .ant-select-selection__rendered) {
    margin-left: 4px;
    line-height: 30px;
  }
}

.locale-block {
  padding: 12px 16px 4px;
  margin-bottom: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
}

.locale-name-item {
  :deep(.ant-form-item-control) {
    line-height: 40px;
  }
}

.locale-name-input {
  width: 420px;
  max-width: 100%;
}
</style>
